<div class="company-detail-wrapper active">
  <div class="company-detail-image" *ngIf="company.logo" [ngStyle]="getCompanyCoverImage(company)">
    <img [src]="company.logo" />
  </div>
  <div class="company-detail-content">
    <div class="company-detail-topics" *ngIf="company.topics.length">
      <div class="company-detail-topic" *ngFor="let item of company.topics">
        <app-ui-tooltip
          [icon]="item.icon"
          [content]="item.desc"
          [title]="item.name"
          size="large"
          (mouseenter)="trackTooltip(item.name)"
        ></app-ui-tooltip>
      </div>
    </div>
    <div class="company-detail-about">
      <p class="category-title">{{ 'companyDescription.section1.title' | translate }}</p>
      <div class="company-detail-infos">
        <div class="company-detail-info">
          <span class="icon-i-location"></span>
          <span>{{ company.based }}</span>
        </div>
        <div class="company-detail-info">
          <span class="icon-i-sector"></span>
          <span>{{ getCompanySector(company) | translate }}</span>
        </div>
        <div class="company-detail-info">
          <span class="icon-i-globe"></span>
          <span>
            <a href="{{ company.link }}" target="_blank">{{ company.link_string }}</a>
          </span>
        </div>
      </div>
      <div *ngIf="company.desc?.length">
        <ng-container *ngIf="company.desc?.length > limitSize[0]; else shortDesc">
          <p [ngClass]="{ 'limit-text': limitDesc }" [innerHtml]="limitDesc ? (company.desc | slice: 0 : limitSize[0]) : company.desc"></p>
          <strong [ngClass]="{ more: limitDesc }" (click)="limitCopy('limitDesc')">{{
            'companyDescription.' + (limitDesc ? 'readMore' : 'showLess') | translate
          }}</strong>
        </ng-container>
        <ng-template #shortDesc>
          <p [innerHtml]="company.desc"></p>
        </ng-template>
      </div>
      <div
        class="extra-copy"
        *ngIf="company.good_bullet_points?.length === 0 && company.bad_bullet_points?.length === 0 && company.extra_desc?.length"
      >
        <ng-container *ngIf="company.extra_desc?.length > limitSize[0]; else shortExtraDesc">
          <p
            [ngClass]="{ 'limit-text': limitExtraDesc }"
            [innerHtml]="limitExtraDesc ? (company.extra_desc | slice: 0 : limitSize[0]) : company.extra_desc"
          ></p>
          <strong [ngClass]="{ more: limitExtraDesc }" (click)="limitCopy('limitExtraDesc')">
            {{ 'companyDescription.' + (limitExtraDesc ? 'readMore' : 'showLess') | translate }}
          </strong>
        </ng-container>
        <ng-template #shortExtraDesc>
          <p [innerHtml]="company.extra_desc"></p>
        </ng-template>
      </div>
    </div>

    <div class="company-detail-list" *ngIf="company.good_bullet_points?.length">
      <p class="category-title">{{ 'companyDescription.section2.title' | translate }}</p>
      <ng-container *ngIf="company.good_bullet_points?.length === 1 && company.good_bullet_points[0].length <= limitSize[1]; else shortenGood">
        <div class="company-detail-list-item">
          <span class="icon-i-checkmark-circle"></span>
          <div>
            <span>{{ company.good_bullet_points[0] }}</span>
          </div>
        </div>
      </ng-container>
      <ng-template #shortenGood>
        <ng-container *ngIf="limitGoodDesc; else showAllGood">
          <div class="company-detail-list-item">
            <span class="icon-i-checkmark-circle"></span>
            <div>
              <span class="limit-text">{{ company.good_bullet_points[0] | slice: 0 : limitSize[1] }}</span>
              <strong class="more" (click)="limitCopy('limitGoodDesc')">{{ 'companyDescription.readMore' | translate }}</strong>
            </div>
          </div>
        </ng-container>
        <ng-template #showAllGood>
          <div class="company-detail-list-item" *ngFor="let item of company.good_bullet_points">
            <span class="icon-i-checkmark-circle"></span>
            <span>{{ item }}</span>
          </div>
          <strong (click)="limitCopy('limitGoodDesc')">{{ 'companyDescription.showLess' | translate }}</strong>
        </ng-template>
      </ng-template>
    </div>
    <div class="company-detail-list" *ngIf="company.bad_bullet_points?.length">
      <p class="category-title">{{ 'companyDescription.section3.title' | translate }}</p>
      <ng-container *ngIf="company.bad_bullet_points?.length === 1 && company.bad_bullet_points[0].length <= limitSize[1]; else shortenBad">
        <div class="company-detail-list-item">
          <span class="icon-i-info"></span>
          <div>
            <span>{{ company.bad_bullet_points[0] }}</span>
          </div>
        </div>
      </ng-container>
      <ng-template #shortenBad>
        <ng-container *ngIf="limitBadDesc; else showAllBad">
          <div class="company-detail-list-item">
            <span class="icon-i-info"></span>
            <div>
              <span class="limit-text">{{ company.bad_bullet_points[0] | slice: 0 : limitSize[1] }}</span>
              <strong class="more" (click)="limitCopy('limitBadDesc')">{{ 'companyDescription.readMore' | translate }}</strong>
            </div>
          </div>
        </ng-container>
        <ng-template #showAllBad>
          <div class="company-detail-list-item" *ngFor="let item of company.bad_bullet_points">
            <span class="icon-i-info"></span>
            <span>{{ item }}</span>
          </div>
          <strong (click)="limitCopy('limitBadDesc')">{{ 'companyDescription.showLess' | translate }}</strong>
        </ng-template>
      </ng-template>
    </div>
  </div>
</div>
